import react from "react";
import { useNavigate } from "react-router-dom";
import ROUTERS from "../../constans/router";
import LazyLoadImg from "../LazyLoadImg";
import { ReactComponent as IconCheckmark } from '../../../assets/images/icon_checkmark_big.svg'

type props = {
  src: Array,
  id: Number,
  photoClass: String,
  onClick: Function
};

const PhotoComponentCustom = ({ id, src, photoClass, onClick, photoSelected, item }: Props) => {

  const navigate = useNavigate();
  const handleClick = (src, id) => {
    if (onClick) {
      onClick(item)
    } else {
      navigate(ROUTERS.ALBUM_DETAIL_PATH(id), {
        state: {item}
      });
    }
  }

  return <>
    <label className={`${photoClass}${photoSelected?.id === id ? " photo-selector" : ''}`}>
      {photoSelected?.id === id && <input type="radio" value={id} checked={photoSelected?.id === id} readOnly/>}
      <div
        className={`${photoSelected?.id === id ? " photo-selector__thumb" : (photoClass + '__thumb')}`}
        onClick={() => handleClick(src, id, item)}
      >
        <LazyLoadImg src={item?.photo_url?.thumbnail || ""} className="album-page__border-image"/>
        {photoSelected?.id === id && <div className="marker">
          <IconCheckmark />
        </div>}
      </div>
    </label>
  </>;
};

PhotoComponentCustom.defaultProps = {
  src: '',
  onClick: false
};

export default PhotoComponentCustom;
